import { decodeExportDetails } from '../utils/decode.util';

export interface ChatAgentConfig {
  company_name: string;
  agent_id: string;
  first_message: string;
}

export const decodeUrlConfig = (pathname: string): Partial<ChatAgentConfig> => {
  try {
    const parts = pathname.split('/');
    const encodedPart = parts[parts.length - 1];
    return decodeExportDetails<ChatAgentConfig>(encodedPart);
  } catch (e) {
    console.warn('Failed to decode URL configuration:', e);
    return {};
  }
};
